import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import PracaForm from '../components/praca/PracaForm';

const PracaNovo: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Nova Praça
        </Typography>
      </Box>
      <PracaForm isEdit={false} />
    </Container>
  );
};

export default PracaNovo;
